import React from 'react';
import './_nav.scss';
import './_nav.dark-mode.scss';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';

const NavRoutes = ({ routes }) => {
  const location = useLocation();

  if (routes && routes.length) {
    return (
      <ul className="p-b nav nav-route nav-pills nav-stacked">
        {routes.map((route, index) => (
          <li key={`nav-route-${index}`}>
            {route.react
              ? (
                <NavLink
                  to={`${route.url}`}
                  isActive={() => route.routesSecondary.includes(location.pathname)}
                >
                  {route.title}
                </NavLink>
              )
              : <a href={`${route.url}`}>{route.title}</a>}
          </li>
        ))}
      </ul>
    )
  }
  return null;
};

NavRoutes.defaultProps = {
  routes: [],
};

NavRoutes.propTypes = {
  routes: PropTypes.array,
};

export default NavRoutes;
